
import { namespace } from "vuex-class";
const common_base = namespace("common_base");
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({})
export default class ComCustomerFlagSelect extends Vue {
  @common_base.Action queryCustomerFlagList;
  @common_base.Action saveCustomerFlag;
  @Prop({
    default: () => [],
    type: Array
  })
  flagData: any;
  @Prop({ default: true, type: Boolean })
  showPop: boolean; // 是否hover显示标签
  @Prop({ default: false, type: Boolean })
  showAll: boolean; // 是否显示所有的标签
  @Prop({ default: false, type: Boolean })
  notHide: boolean; // 值为空的时候直接隐藏不显示 “-”
  show: boolean = false;
  hidden: boolean = true;
  filterFlagData: any = [];
  selfWidth = 0;

  mounted() {
    this.init();
  }
  init() {
    this.filterFlagData = this.flagData;
    if (this.showAll) {
      this.hidden = false;
      return;
    }
    this.hidden = true;
    let basisWidth = 4; // margin-right 值
    this.$nextTick(() => {
      if (this.$refs.flagSelf) {
        this.selfWidth = (this.$refs.flagSelf as any).clientWidth - 20; // 20容错
      }

      this.$nextTick(() => {
        const itemDomArr = (this.$refs.flagSelf as any).querySelectorAll(".flag-item-dom");
        let allWidth = 0;
        let tempArr = [];

        for (let i = 0; i < itemDomArr.length; i++) {
          let width = itemDomArr[i].clientWidth;
          allWidth += width + basisWidth;

          if (allWidth < this.selfWidth) {
            tempArr.push(this.flagData[i]);
          } else {
            break;
          }
        }
        this.filterFlagData = tempArr;
        this.hidden = false;
      });
    });
  }
  @Watch("flagData", {
    immediate: false
  })
  flagDataChange() {
    this.$nextTick(() => {
      this.init();
    });
  }
  handleHover() {
    if (this.showPop) {
      this.show = true;
    }
  }
}
